"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_shared_js_1 = require("@tableau/api-shared-js");
class WorkbookFormattingEnvUtil {
    static convertToWorkbookFormatting(workbookFormattingModel) {
        if (!workbookFormattingModel) {
            return undefined;
        }
        else {
            const formattingMap = workbookFormattingModel.formattingSheets.map((currentFormattingSheet) => {
                const formattingSheet = {
                    classNameKey: api_shared_js_1.InternalToExternalEnumMappings.classNameKey.convert(currentFormattingSheet.classNameKey),
                    cssProperties: getCssProperties(currentFormattingSheet.classNameKey, currentFormattingSheet.cssProperties),
                };
                return formattingSheet;
            });
            const result = {
                formattingSheets: formattingMap,
            };
            return result;
        }
    }
}
exports.WorkbookFormattingEnvUtil = WorkbookFormattingEnvUtil;
function getCssProperties(classNameKey, cssProperties) {
    if (classNameKey === "tableau-row-dividers" /* RowDividers */ || classNameKey === "tableau-column-dividers" /* ColumnDividers */) {
        return {
            borderColor: cssProperties.borderColor,
            borderStyle: cssProperties.borderStyle,
            borderWidth: cssProperties.borderWidth,
        };
    }
    return {
        fontFamily: cssProperties.fontFamily,
        fontSize: cssProperties.fontSize,
        fontWeight: cssProperties.fontWeight,
        fontStyle: cssProperties.fontStyle,
        textDecoration: cssProperties.textDecoration,
        color: cssProperties.color,
    };
}
//# sourceMappingURL=WorkbookFormattingEnvUtil.js.map